import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-e404',
  templateUrl: './e404.component.html',
  styleUrls: ['./e404.component.scss']
})
export class E404Component {

  constructor(private router: Router) { }

  goToHome() {
    this.router.navigate(['']);
  }

}
